// @flow
import styled, { css } from 'styled-components';

import {
  CardCVCElement,
  CardExpiryElement,
  CardNumberElement,
  PostalCodeElement,
} from 'react-stripe-elements';

import {
  WHITE,
  GREY_10,
  ERROR_PRIMARY,
  CLARK_PRIMARY,
  CLARK_SECONDARY,
  CLARK_TERTIARY,
  LINK_COLOR_PRIMARY,
} from 'styles/colors';
import { SPACING_EXTRA_SMALL, SPACING_SMALL, SPACING_MEDIUM, SPACING_LARGE } from 'styles/spacing';
import { FONT_WEIGHT_100, FONT_WEIGHT_400 } from 'styles/font-weight';
import { TYPE_SCALE_F3, TYPE_SCALE_F4 } from 'styles/type-scale';
import { BORDER_RADIUS_F2 } from 'styles/border-radius';
import { BORDER_WIDTH_1 } from 'styles/borders';

export const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '18px',
      color: CLARK_SECONDARY,
      '::placeholder': {
        color: GREY_10,
        fontWeight: 100,
      },
    },
    invalid: {
      color: CLARK_SECONDARY,
    },
  },
};

export const FormInput = css`
  ${TYPE_SCALE_F4};
  ${FONT_WEIGHT_100};
  ${BORDER_RADIUS_F2};
  border: ${BORDER_WIDTH_1} solid ${props => (!props.showError ? GREY_10 : CLARK_PRIMARY)};
  color: ${CLARK_SECONDARY};
  display: block;
  line-height: 1;
  padding: calc(${SPACING_EXTRA_SMALL} + ${SPACING_SMALL});
  position: relative;
  outline: none;
  width: 100%;
  margin-bottom: ${props => (!props.showError ? 0 : SPACING_SMALL)};
  background-color: ${props => (!props.showError ? WHITE : ERROR_PRIMARY)};
  transition: 0.5s;
  z-index: ${props => (!props.showError ? 0 : 9)};

  &::placeholder {
    color: ${GREY_10};
  }
`;

export const ButtonWrapper = styled.div`
  margin-bottom: ${SPACING_SMALL};
`;

export const CardCVC = styled<any>(CardCVCElement)`
  ${FormInput};
  border-radius: 0;
  margin-left: -${BORDER_WIDTH_1};
  width: 101%; /* overlap right side */
`;

export const CardExpiry = styled<any>(CardExpiryElement)`
  ${FormInput};
  border-radius: ${SPACING_EXTRA_SMALL} 0 0 ${SPACING_EXTRA_SMALL};
  margin-right: -${BORDER_WIDTH_1};
`;

export const CardNumber = styled<any>(CardNumberElement)`
  ${FormInput};
`;

export const FieldContent = styled.div`
  margin-bottom: calc(${SPACING_SMALL} + ${SPACING_MEDIUM});
`;

export const FieldsetContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FieldsetContent = styled.div`
  margin-bottom: calc(${SPACING_SMALL} + ${SPACING_MEDIUM});
  width: calc(100% / 3);
`;

export const Form = styled.form``;

export const Label = styled.label`
  color: ${CLARK_SECONDARY};
  display: block;
  margin-bottom: ${SPACING_SMALL};
`;

export const PostalCode = styled<any>(PostalCodeElement)`
  ${FormInput};
  border-radius: 0 ${SPACING_EXTRA_SMALL} ${SPACING_EXTRA_SMALL} 0;
  margin-left: -${BORDER_WIDTH_1};
`;

export const SubmitContainer = styled.div`
  background-color: ${WHITE};
  padding: ${SPACING_LARGE} 0;
`;

export const SubmitInfo = styled.div`
  margin-bottom: ${SPACING_LARGE};
`;

export const SubmitInfoHeadline = styled.h3`
  ${FONT_WEIGHT_400};
  ${TYPE_SCALE_F3};
  color: ${CLARK_SECONDARY};
  margin: 0;
`;

export const SubText = styled.div`
  align-items: center;
  display: flex;
  color: ${LINK_COLOR_PRIMARY};
  margin-bottom: calc(${SPACING_SMALL} + ${SPACING_MEDIUM});
  margin-top: -${SPACING_MEDIUM};
`;

export const AgreeToTerms = styled.div`
  align-items: flex-start;
  display: flex;
`;

export const AgreeToTermsText = styled.div`
  margin-left: 0.5em;
  line-height: 2rem;
`;

export const Link = styled.a`
  border-bottom: ${BORDER_WIDTH_1} dotted ${CLARK_TERTIARY};
  color: ${CLARK_TERTIARY};
  text-decoration: none;
`;



// WEBPACK FOOTER //
// ./src/containers/payer/charge-form/styles.js